import classNames from 'classnames';
import Modal from 'react-modal';

export interface ModalShellProps {
  showModal: boolean;
  className?: string;
  children?: React.ReactNode;
  onClose?: () => void;
}

const ModalShell = ({
  showModal,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose = () => {},
  children = '',
  className = '',
}: ModalShellProps) => (
  <Modal
    isOpen={showModal}
    onRequestClose={onClose}
    ariaHideApp={false}
    contentLabel="My dialog"
    className={classNames(
      'fixed top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-bg p-7 translate-1/2 rounded-lg flex justify-center items-center max-h-[80%]',
      className,
    )}
    overlayClassName="ty-uploaded-image-modal-overlay"
  >
    {children}
  </Modal>
);

export default ModalShell;
